export default __webpack_public_path__ + "static/logo_porlisboa-a0c70ce89f91abcfa301bfee132772a3.png";